import { Box, Stack } from '@mantine/core';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import {
  setSearchTerm,
  setTableSortBy,
  setTableSortDirection,
} from '../../../store/strategy-store/strategy-store.actions';
import { StrategyEntityTable } from '../components/strategy-entity-table';
import { EpicsMainSectionControls } from './epics-main-section-controls';
import { EpicsMainSectionGrouped } from './epics-main-section-grouped';
import { useFilteredEpics, handleDownloadCSV } from './epics-main-section.helpers';

export interface EpicsMainSectionProps {
  isLoading: boolean;
}

export const EpicsMainSection = ({ isLoading }: EpicsMainSectionProps) => {
  const { t } = useTranslation();
  const tableGroupBy = useStrategyStore((state) => state.tableGroupBy);
  const tableSortBy = useStrategyStore((state) => state.tableSortBy);
  const tableSortDirection = useStrategyStore((state) => state.tableSortDirection);
  const searchTerm = useStrategyStore((state) => state.searchTerm);
  const [currentPage, setCurrentPage] = useState(1);

  // Filter epics by search term, due date state, and projects
  const filteredEpics = useFilteredEpics();

  const handleExport = () => {
    handleDownloadCSV(filteredEpics, t);
  };

  const handleSearch = useCallback((term: string) => {
    setSearchTerm(term);
  }, []);

  return (
    <Stack h="100%" style={{ overflow: 'hidden' }} gap="xs">
      <EpicsMainSectionControls
        epics={filteredEpics}
        onSearch={handleSearch}
        onExport={handleExport}
        searchTerm={searchTerm}
      />
      <Box style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        {isLoading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading epics...</div>
        ) : tableGroupBy && tableGroupBy !== null ? (
          <EpicsMainSectionGrouped groupBy={tableGroupBy} epics={filteredEpics} />
        ) : (
          <StrategyEntityTable
            entities={filteredEpics as any}
            entityType="epic"
            onEntityClick={() => {}}
            page={currentPage}
            onPageChange={setCurrentPage}
            tableSortBy={tableSortBy}
            tableSortDirection={tableSortDirection}
            onSortChange={(field, dir) => {
              setTableSortBy(field as any);
              setTableSortDirection(dir as any);
            }}
            showTeamsColumn={true}
            filtersApplied={true}
          />
        )}
      </Box>
    </Stack>
  );
};
